import { createCrudSlice, createCrudSelectors } from "./CrudRedux";

const smDefinitionsSlice = createCrudSlice({
  name: "smDefinitions",
});

export const SmDefinitionsActions = smDefinitionsSlice.actions;

export const SmDefinitionsSelectors = {
  ...createCrudSelectors({ name: "smDefinitions" }),
};

export default smDefinitionsSlice.reducer;
